import AgendaDetalhe from './AgendaDetalhe';

export default AgendaDetalhe;